import { render, staticRenderFns } from "./LicenseApply.vue?vue&type=template&id=d2217f78&scoped=true"
import script from "./LicenseApply.vue?vue&type=script&lang=js"
export * from "./LicenseApply.vue?vue&type=script&lang=js"
import style0 from "./LicenseApply.vue?vue&type=style&index=0&id=d2217f78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2217f78",
  null
  
)

export default component.exports